module.exports = __webpack_public_path__ + "static/spellbook-mtg_afr-afdb0fdd7c16b98642f8df904ff20e19.jpg";